import { createRouter, createWebHistory } from 'vue-router';
import Home from "../views/Home.vue";
import Store from "@/store";
import i18n from "@/plugins/i18n";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: 'Home'
    }
  },
  //TEMP
  {
    path: "/hbeconfig",
    name: "HBEConfig",
    component: () =>
      import(/* webpackChunkName: "hbeconfig" */ "../views/HBEConfig/HBEConfig.vue"),
  },
  {
    path: "/result",
    name: "Result",
    component: () =>
      import(/* webpackChunkName: "result" */ "../views/resultPage/Result.vue"),
    meta: {
      title: 'Result'
    }
  },
  {
    path: "/detail",
    name: "Detail",
    component: () =>
      import(/* webpackChunkName: "detail" */ "../views/detail/Detail.vue"),
    meta: {
      title: 'Detail'
    }
  },
  {
    path: "/booking",
    name: "Booking",
    component: () =>
      import(/* webpackChunkName: "booking" */ "../views/booking/Booking.vue"),
    meta: {
      title: 'Booking'
    }
  },
  {
    path: "/guarantee",
    name: "Guarantee",
    component: () =>
      import(
        /* webpackChunkName: "guarantee" */ "../views/guaranteePage/Guarantee.vue"
      ),
    meta: {
      title: 'Guarantee'
    }
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: () =>
      import(
        /* webpackChunkName: "confirmation" */ "../views/confirmation/confirmation.vue"
      ),
    meta: {
      title: 'Confirmation'
    }
  },
  {
    path: "/mapResultMobile",
    name: "MapResultMobile",
    component: () =>
      import(
        /* webpackChunkName: "mapResultMobile" */ "../views/mapResult/mapResultMobile.vue"
      ),
    meta: {
      title: 'MapResultMobile'
    }
  },
  {
    path: "/mapHotelListMobile",
    name: "MapHotelListMobile",
    component: () =>
      import(
        /* webpackChunkName: "mapHotelListMobile" */ "../views/mapResult/mapHotelListMobile.vue"
      ),
    meta: {
      title: 'MapHotelListMobile'
    }
  },
  {
    path: "/gaodeMap",
    name: "gaodeMap",
    component: () =>
      import(/* webpackChunkName: "gaodeMap" */ "../views/mapResult/gaodeMap.vue"),
    meta: {
      title: 'GaodeMap'
    }
  },
  {
    path: "/manualOrder",
    name: "manualOrder",
    component: () => import(/* webpackChunkName: "manualOrder" */ "../views/manualOrder/ManualOrder.vue"),
  },
  {
    path: "/orderList",
    name: "orderList",
    component: () => import(/* webpackChunkName: "orderList" */ "../views/orderList/OrderList.vue"),
    meta: {
      title: 'OrderList'
    }
  },
  {
    path: "/eguarantee",
    name: "EGuarantee",
    component: () =>
      import(
        /* webpackChunkName: "eguarantee" */ "../views/guaranteePage/EGuarantee.vue"
      ),
    meta: {
      title: 'EGuarantee'
    }
  },
  {
    path: "/travelRules",
    name: "travelRules",
    component: () => import(/* webpackChunkName: "travelRules" */ "../views/travelRules/TravelRules.vue"),
  },
  {
    path: "/bannerConfig",
    name: "BannerMaintain",
    component: () =>
      import(/* webpackChunkName: "bannerConfig" */ "../views/bannerConfig/BannerMaintain.vue"),
  },
  {
    path: "/smslog",
    name: "SMSLog",
    component: () =>
      import(/* webpackChunkName: "smslog" */ "../views/smslog/SMSLog.vue"),
  },
  {
    path: "/syncHotel",
    name: "HBESyncHotel",
    component: () =>
      import(/* webpackChunkName: "syncHotel" */ "../views/HBEConfig/HBEHotelDataMatching.vue"),
  },
  {
    path: "/PayOrder",
    name: "PayOrder",
    component: () =>
      import(
        /* webpackChunkName: "PayOrder" */ "../views/pay/PayOrder.vue"
      ),
    meta: {
      title: 'PayOrder'
    }
  },
  {
    path: "/refundList",
    name: "RefundList",
    component: () =>
      import(
        /* webpackChunkName: "refundList" */ "../views/refund/RefundList.vue"
      ),
  },
  {
    path: "/invoicing",
    name: "Invoicing",
    component: () =>
      import(
        /* webpackChunkName: "invoicing" */ "../views/invoices/invoicing.vue"
      ),
    meta: {
      title: 'Invoicing'
    }
  },
  {
    path: "/incidentReport",
    name: "IncidentReport",
    component: () => import(/* webpackChunkName: "incidentReport" */ "../views/incident/IncidentReport.vue"),
    meta: {
      title: 'IncidentReport'
    }
  },
  {
    path: "/invoicesConfig",
    name: "InvoicesConfig",
    component: () => import(/* webpackChunkName: "invoicesConfig" */ "../views/invoices/invoicesConfig.vue"),
  },
  {
    path: "/invoicingList",
    name: "invoicingList",
    component: () =>
      import(
        /* webpackChunkName: "invoicingList" */ "../views/invoices/invoicingList.vue"
      ),
  },
  {
    path: "/hotelMonitor",
    name: "hotelMonitor",
    component: () =>
      import(
        /* webpackChunkName: "hotelMonitor" */ "../views/monitor/hotelMonitor.vue"
      ),
  },
];

console.log("process.env.BASE_URL:", process.env.BASE_URL);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

function setPageTitle(to) {
  let title = 'MyCWT';
  if (to.meta.title !="Home") {
    title = `MyCWT - ${i18n.global.t(`route.${to.meta.title}`)} `;
  }else {
    let destinationType = sessionStorage.getItem("OBTdestinationType");
    if (destinationType == "D") {
      title = `MyCWT - ${i18n.global.t(`HEADER.FL04`)}`;
    } else if (destinationType == "I") {
      title = `MyCWT - ${i18n.global.t(`HEADER.FL10`)}`;
    }
  }
  
  document.title = title;
}
const PRESERVED_ROUTE_NAMES = {
  RESULT: 'Result',
  DETAIL: 'Detail'
}
router.beforeEach(async (to, from, next) => {
  const isBetweenPreservedRoutes = 
    [PRESERVED_ROUTE_NAMES.RESULT, PRESERVED_ROUTE_NAMES.DETAIL].includes(to.name) && 
    [PRESERVED_ROUTE_NAMES.RESULT, PRESERVED_ROUTE_NAMES.DETAIL].includes(from.name) &&
    to.name !== from.name; // 确保不是同页面刷新
  
  // 如果不是在两个指定路由之间跳转，则清除数据
  if (!isBetweenPreservedRoutes) {
    sessionStorage.removeItem('resultData');
  }
  setPageTitle(to)
  let query = Store.state.pathQuery;
  let toQuery = to.query;

  if (!toQuery.searchParam && query.searchParam) {
    let searchParam = JSON.parse(query.searchParam);
    if (toQuery.checkInAt) searchParam.checkInAt = toQuery.checkInAt;
    if (toQuery.checkOutAt) searchParam.checkOutAt = toQuery.checkOutAt;
    if (toQuery.city) searchParam.city = toQuery.city;
    if (toQuery.guestCount) searchParam.guestCount = toQuery.guestCount;
    if (toQuery.keyword) searchParam.keyword = toQuery.keyword;
    if (toQuery.roomCount) searchParam.roomCount = toQuery.roomCount;

    query.searchParam = JSON.stringify(searchParam);
  }
  Object.assign(query, toQuery);
  Store.commit("changePathQuery", query);

  // 订单详情页是否展示其他产品
  // 在 Vue 3 中，需要通过其他方式访问全局属性
  // 这里假设 $objBaseInfo 已经通过 app.config.globalProperties 设置
  // 或者在组件中通过 use 注入
  
  if (from.path.includes("booking") || from.path.includes("eguarantee") || from.path.includes("guarantee")) {
    // 在 Vue 3 中，需要通过其他方式设置全局属性
    // 这里暂时注释掉，需要在组件级别处理
    // $objBaseInfo.showOtherProduct = true;
  } else if (!from.path.includes("confirmation")) {
    // $objBaseInfo.showOtherProduct = false;
  }
  
  if (from.name) {
    sessionStorage.setItem('previousPage', from.name);
  }
  next();
});

// 监听语言变化，重新设置标题
export function updateRouteTitles() {
  const currentRoute = router.currentRoute.value;
  setPageTitle(currentRoute);
}

export default router;